import { useLang } from "@/context/LanguageContext";
import { islandUrl, tr } from "@/lib/translations";
import { LandingPage } from "@/components/LandingPage";
import { AdminEditButton } from "@/components/AdminEditButton";
import { hasBlocks, mergeBlocks, filterPlaces } from "@/lib/landingBlocks";
import { PlaceChips, IslandsBlock } from "@/components/LandingBlocks";
import { HighlightsSection } from "@/components/HighlightsSection";

const L = {
  de: { badge: "Region", places: "Orte in {r}", back: "Alle Objekte auf {n}", props: "Ferienobjekte in {r}" },
  en: { badge: "Region", places: "Places in {r}", back: "All properties on {n}", props: "Holiday rentals in {r}" },
  es: { badge: "Región", places: "Lugares en {r}", back: "Todos los alojamientos en {n}", props: "Alojamientos en {r}" },
  nl: { badge: "Regio", places: "Plaatsen in {r}", back: "Alle accommodaties op {n}", props: "Vakantiehuizen in {r}" },
  pl: { badge: "Region", places: "Miejscowości – {r}", back: "Wszystkie obiekty – {n}", props: "Obiekty wakacyjne – {r}" },
  fr: { badge: "Région", places: "Localités à {r}", back: "Tous les hébergements à {n}", props: "Locations de vacances à {r}" },
  it: { badge: "Regione", places: "Località a {r}", back: "Tutti gli alloggi a {n}", props: "Case vacanza a {r}" },
};

export default function RegionPage({ data }) {
  const { lang, t } = useLang();
  const l = L[lang] || L.en;
  const c = tr(data.content, lang);
  const name = tr(data.name, lang);
  const islandName = data.island_name[lang] || data.island_name.en;
  const std = !data.hero_image && data.hero_fallback?.source === "default";
  const heroProp = [...data.properties].sort((a, b) => (a.ref_number || 0) - (b.ref_number || 0))[0];
  const fb = !data.hero_image && (std || !heroProp?.hero_image) ? data.hero_fallback : null;
  const hero = data.hero_image || (std ? fb.url : heroProp?.hero_image || fb?.url);
  const base = islandUrl(data.island);
  const deSections = (data.content?.de || {}).sections;
  const placed = hasBlocks(deSections);
  const heading = l.places.replace("{r}", name);
  return (
    <>
    <AdminEditButton kind="region" id={data.id} />
    <LandingPage
      testid="region-page" heroImage={hero} heroPosition={data.hero_image ? data.hero_position : fb ? fb.position : "center"} heroAlt={data.hero_image ? tr(data.hero_alt, lang) : fb ? tr(fb.alt, lang) : ""} badge={`${islandName} · ${l.badge}`} content={{ ...c, sections: mergeBlocks(c.sections, deSections) }} properties={data.properties} island={data.island}
      blocks={{ places: (s) => <PlaceChips places={filterPlaces(data.places, s.slugs)} base={base} heading={heading} testId="region-places" chipId="region-place" />, islands: () => <IslandsBlock island={data.island} /> }}
      afterIntro={<HighlightsSection items={data.highlights} title={t.island.highlights.replace("{n}", name)} />}
      propertiesTitle={l.props.replace("{r}", name)} ctaLabel={l.back.replace("{n}", islandName)} ctaTo={base}
      breadcrumb={[{ name: t.nav.home, to: "/" }, { name: islandName, to: base }, { name, to: `${base}/${data.slug}` }]}
      jsonLd={{ "@context": "https://schema.org", "@type": "TouristDestination", name, description: c.meta_description, image: hero, url: window.location.href, containedInPlace: { "@type": "Place", name: islandName } }}
    >
      {!placed && <PlaceChips places={data.places} base={base} heading={heading} placed={false} testId="region-places" chipId="region-place" />}
    </LandingPage>
    </>
  );
}
